<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="mb-3">
            <!-- <router-link
              to="/panel_aliados"
              class="btn btn-orange rounded-pill"
            >
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link> -->
            <button_back></button_back>
          </div>
        </div>
      </div>
    </transition>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body">
            <div class="form-group">
              <label>Buscar</label>
              <v-select v-model="aliado_search" @search="get_aliados" @input="select_aliado" label="nombre_aliado"
                :options="aliados"></v-select>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div v-if="aliado.estado_aliado == 2" class="alert alert-success fw-bold">
            Completo
          </div>
          <div v-if="aliado.estado_aliado == 3" class="alert alert-warning fw-bold">
            Exitoso
          </div>
          <div v-if="aliado.estestado_aliadoado == 1" class="alert alert-danger fw-bold">
            Pendiente
          </div>
          <div v-if="aliado.estado_aliado == 0" class="alert alert-info fw-bold">
            Interesado
          </div>
        </div>
        <div class="col-md-4 col-xl-3">
          <div class="card mb-3">
            <div class="card-header">
              <h4 class="fw-bold text-center text-orange mb-0">
                {{ aliado.nombre_aliado }}
              </h4>
            </div>
            <div class="card-body text-center">
              <img v-if="aliado.logo != null" v-bind:src="aliado.logo" alt="Logo Aliado"
                class="img-fluid rounded-circle mb-2" width="128" height="128" />
            </div>
            <hr class="my-0" />
            <div class="card-body text-center">
              <div class="d-grid gap-2">
                <a v-if="anexos.pieza_revista != null" v-bind:href="anexos.pieza_revista" target="_blank"
                  class="btn btn-orange rounded-pill">
                  Pieza revista
                </a>
                <a v-if="anexos.pieza_redes != null" v-bind:href="anexos.pieza_redes" target="_blank"
                  class="btn btn-orange rounded-pill">
                  Pieza redes
                </a>

                <a v-if="anexos.pieza_historias != null" v-bind:href="anexos.pieza_historias" target="_blank"
                  class="btn btn-orange rounded-pill">
                  Pieza historias
                </a>

                <a v-if="anexos.pieza_app != null" v-bind:href="anexos.pieza_app" target="_blank"
                  class="btn btn-orange rounded-pill">
                  Pieza app
                </a>

                <a v-if="anexos.portafolio != null" v-bind:href="anexos.portafolio" target="_blank"
                  class="btn btn-orange rounded-pill">
                  Portafolio
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-xl-9">
          <div class="card">
            <div class="card-body h-100">
              <div class="row">
                <div class="col-lg-12 form-group">
                  <label>Agente</label>
                  <h6 v-if="aliado.usuario != null" class="fw-bold text-orange text-uppercase">
                    {{ aliado.usuario.nombre_completo }}
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Nombre</label>
                  <h6 class="fw-bold text-orange">
                    {{ aliado.nombre_aliado }}
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Zona</label>
                  <h6 v-if="aliado.zona == 1" class="fw-bold text-orange">
                    Norte
                  </h6>
                  <h6 v-if="aliado.zona == 2" class="fw-bold text-orange">
                    Sur
                  </h6>
                  <h6 v-if="aliado.zona == 3" class="fw-bold text-orange">
                    Este
                  </h6>
                  <h6 v-if="aliado.zona == 4" class="fw-bold text-orange">
                    Oeste
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Teléfono / Whatsapp</label>
                  <h6 class="fw-bold text-orange">
                    {{ aliado.telefono }} / {{ aliado.whatsapp }}
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Categoría</label>
                  <h6 class="fw-bold text-orange">
                    {{ aliado.categoria }}
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Redes</label><br />
                  <small>Facebook</small>
                  <h6 class="fw-bold text-orange">
                    {{ aliado.facebook }}
                  </h6>
                  <small>Instagram</small>
                  <h6 class="fw-bold text-orange">
                    {{ aliado.instagram }}
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Nombre contacto</label>
                  <h6 class="fw-bold text-orange">
                    {{ aliado.nombre_contacto }}
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Ubicación</label>
                  <h6 class="fw-bold text-orange">
                    {{ aliado.direccion }}
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Correo</label>
                  <h6 class="fw-bold text-orange">
                    {{ aliado.email }}
                  </h6>
                </div>
                <div class="col-lg-6 form-group">
                  <label>Personal</label>
                  <h6 class="fw-bold text-orange">
                    <span>Operativo: </span>{{ aliado.personal_operativo
                    }}<br />
                    <span>Administrativo: </span>{{ aliado.personal_admin }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import "vue-select/dist/vue-select.css";
import { defineAsyncComponent } from 'vue';
import { AliadosService } from '../../services/AliadosService';
export default {
  name: "Aliado_ficha",
  metaInfo: {
    title: "Ficha del aliado - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      loading_anexos: true,
      id_aliado: null,
      aliado: [],
      anexos: [],
      aliados: [],
      aliado_search: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.get_aliado();
  },
  methods: {
    get_aliado: function () {
      this.loading = true;
      AliadosService.getAliado(this.session.token, this.id_aliado)
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliado = response.data.data;
          this.get_anexos();
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_anexos: function () {
      this.loading_anexos = true;
      AliadosService.getAnexosFicha(this.session.token, this.id_aliado)
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.anexos = response.data.data.anexos;
          console.log(this.anexos)
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_aliados: function (search) {
      if (search == null || search.trim().length == 0) {
        return false;
      }
      let params = { search: search };
      AliadosService.getAliados(this.session.token, params)
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliados = response.data.data.aliados;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    generar_contrato() {
      window.open(
        this.$base_url + "download/contrato/" + this.id_aliado,
        "_blank"
      );
    },
    select_aliado: function () {
      if (this.aliado_search != null) {
        this.$router.push("/aliado/ficha/" + this.aliado_search.id_aliado);
      }
    },
  },
  mounted: function () { },
  watch: {
    $route() {
      this.id_aliado = this.$route.params.id_aliado;
      this.get_aliado();
    },
  },
};
</script>